import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  CaraPerio,
  EntradaDientePerio,
} from "app/models/periodontograma.interface";
import { CARAS_PERIO, SITIOS, FURCAS, PRONOSTICOS, entradaVacia } from "app/shared/periodontograma/catalogo-periodontograma";
import { NOMBRES_FDI } from "app/shared/odontograma/catalogo-condiciones";

export interface PerioPopoverData {
  fdi: string;
  entry: EntradaDientePerio;
}

@Component({
  selector: "app-perio-popover",
  templateUrl: "./perio-popover.component.html",
  styleUrls: ["./perio-popover.component.scss"],
})
export class PerioPopoverComponent {
  fdi: string;
  nombreFdi: string;
  caras = CARAS_PERIO;
  sitios = SITIOS;
  furcas = FURCAS;
  movilidades = [0, 1, 2, 3];
  pronosticos = PRONOSTICOS;
  entry: EntradaDientePerio;

  constructor(
    private dialogRef: MatDialogRef<PerioPopoverComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PerioPopoverData,
  ) {
    this.fdi = data.fdi;
    this.nombreFdi = NOMBRES_FDI[data.fdi] ?? data.fdi;
    this.entry = JSON.parse(JSON.stringify(data.entry ?? entradaVacia()));
  }

  guardar(): void {
    this.dialogRef.close(this.entry);
  }

  limpiar(): void {
    this.dialogRef.close(entradaVacia());
  }

  cancelar(): void {
    this.dialogRef.close();
  }

  tituloCara(cara: CaraPerio): string {
    return cara === "vestibular" ? "Vestibular" : "Palatino / Lingual";
  }
}
